export default "__VITE_ASSET__euO_SBRw__"